import React from "react";
import styled from "styled-components";
import { colors } from "../../Assets/styles/colors";
import { useTranslate } from '@tolgee/react';
import { Item, Menu } from "react-contexify";

const CustomItem = ({ text, icon, redButton }) => {
  return (
    <CustomItemContainer redButton={redButton}>
      <p>{text}</p>
      {icon}
    </CustomItemContainer>
  );
};


const CallListContextMenu = ({
  selectedContextMenuItem,
  setDeleteConfirmationOpen,
}) => {
  const MENU_ID = "callList-id";
  const { t } = useTranslate();
  const buttonList = [
    {
      id: "delete_call",
      text: t('context_menu.delete_call'),
      redButton: true,
      withConfirmation: true,
    },
  ];
  function handleItemClick({ id }) {
    switch (id) {
      case "delete_call":
        setDeleteConfirmationOpen(true);
        break;

      default:
        break;
    }
  }
  const filterButtons = (buttons) => {
    let availableOptions = buttons;
    if (!selectedContextMenuItem) {
      return availableOptions;
    }
    if (selectedContextMenuItem?.with_emotii) {
      availableOptions = [];
    }

    return availableOptions;
  };

  return (
    <StyledMenu id={MENU_ID}>
      {filterButtons(buttonList).map((item, index) => (
        <Item onClick={handleItemClick} id={item.id} key={index}>
          <CustomItem
            onClick={handleItemClick}
            text={item.text}
            redButton={item.redButton}
          />
        </Item>
      ))}
    </StyledMenu>
  );
};

export default CallListContextMenu;

const StyledMenu = styled(Menu).attrs({
  // custom props
})`
  overflow: hidden;

  background: transparent;
  color: white;
  padding: 0;
  border-radius: 12px;
  .contexify_item {
    background: ${({ theme }) => theme.menu.groupContentBackground};
    border-bottom: 0.5px solid rgba(255, 255, 255, 0.1);

    &:last-child {
      border-bottom: none;
      border-radius: 0 0 12px 12px;
    }
  }
  .contexify_itemContent {
    color: ${colors.errorColor};
  }
  .contexify_item:not(.contexify_item-disabled):hover > .contexify_itemContent,
  .contexify_item:not(.contexify_item-disabled):focus > .contexify_itemContent {
    color: inherit;
    background: ${({ theme }) => theme.chat.selectedBackground};
  }
`;

const CustomItemContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  color: ${({ theme, redButton }) =>
    redButton ? theme.menu.deleColor : theme.menu.primaryTextColor};
  padding: 6px 10px;
  svg {
    height: 20px;
    width: 20px;
  }
`;
